import { memoize, orderBy } from "lodash";
import { computed, observable, runInAction } from "mobx";

import { apiGetOnCallTeamMembers } from "../../../api/developer-api/api-call-get-on-call-team-members";
import { apiUpdateOnCallTeamMember } from "../../../api/developer-api/api-call-update-on-call-team-member";
import { TOnCallTeamMembersArray, TOnCallTeams } from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";
import { TEt3PickerSingleValue } from "../../../TypesNEW";

class OnCallTeamStore {
  onDutyOnCallTeam = observable.box<TOnCallTeamMembersArray>([]);
  onDutyOnCallTeamUpdated = observable.box<TOnCallTeamMembersArray>([]);

  isOnCallChanged = computed(() => {
    const onDutyUpdatedArrayIDs = this.onDutyOnCallTeamUpdated
      .get()
      .map((members) => {
        return members.id;
      });
    const onDutyOldArrayIDs = this.onDutyOnCallTeam
      .get()
      .filter((item) => item.onDuty === 1)
      .map((members) => {
        return members.id;
      });
    const hasChangedA = onDutyOldArrayIDs
      .map((id) => {
        return onDutyUpdatedArrayIDs.indexOf(id) < 0;
      })
      .filter((item) => item);

    return hasChangedA.length > 0;
  });

  getDepartmentOnCallMembers = (team: TOnCallTeams) => {
    const onCallTeamArray = this.onDutyOnCallTeam.get();
    const departmentOnCallMembers = onCallTeamArray
      .filter((member) => {
        return member.team === team;
      })
      .map((teamMember) => {
        return {
          label: teamMember.name,
          value: teamMember.name
        };
      });

    return departmentOnCallMembers;
  };

  updateOnCallTeamArrays = (arrayFromServer: TOnCallTeamMembersArray) => {
    this.setOnDutyOnCallTeam(arrayFromServer);
    this.setOnDutyOnCallUpdate(arrayFromServer);
  };

  setOnDutyOnCallTeam = (team: TOnCallTeamMembersArray) => {
    runInAction(() => {
      this.onDutyOnCallTeam.set(team);
    });
  };

  setOnDutyOnCallUpdate = (team: TOnCallTeamMembersArray) => {
    const updatedTeam = team.filter((item) => item.onDuty === 1);
    runInAction(() => {
      this.onDutyOnCallTeamUpdated.set(updatedTeam);
    });
  };

  getOnCallTeamMembers = async () => {
    getCoreUIStore().setIsLoading("DEVELOPER_ON_CALL_TEAM", true);
    const { status, data, code } = await apiGetOnCallTeamMembers();
    getCoreUIStore().setIsLoading("DEVELOPER_ON_CALL_TEAM", false);
    if (status === "OK") {
      this.updateOnCallTeamArrays(data);
      getCorePopUpStore().showSuccessMessage("SUCCESS");
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
  updateOnCallTeamMember = async () => {
    const onDutyOnCallTeamUpdated = this.onDutyOnCallTeamUpdated.get();
    const onDutyOnCallTeam = this.onDutyOnCallTeam.get();
    const onDutyUpdatedArrayIDs = onDutyOnCallTeamUpdated.map((members) => {
      return members.id;
    });
    const onDutyOldArrayIDs = onDutyOnCallTeam.map((members) => {
      return members.id;
    });
    getCoreUIStore().setIsLoading("DEVELOPER_ON_CALL_TEAM", true);
    const { status, code } = await apiUpdateOnCallTeamMember(
      onDutyUpdatedArrayIDs,
      onDutyOldArrayIDs
    );
    getCoreUIStore().setIsLoading("DEVELOPER_ON_CALL_TEAM", false);
    if (status === "OK") {
      await this.getOnCallTeamMembers();
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
  setOnCallmember = (value: TEt3PickerSingleValue, team: TOnCallTeams) => {
    const choosenMemberArray = this.onDutyOnCallTeam.get().filter((item) => {
      return item.team === team && item.name === value.value;
    })[0];
    const setChosenMemberOnDuty = { ...choosenMemberArray, onDuty: 1 };
    const filteredChoosenArray = this.onDutyOnCallTeamUpdated
      .get()
      .map((item) => {
        return item.team === team ? setChosenMemberOnDuty : item;
      });
    this.setOnDutyOnCallUpdate(filteredChoosenArray);
  };

  getSelectedMember = (team: "QA" | "SE") => {
    const onCallTeamArray = this.onDutyOnCallTeamUpdated.get();
    const selectedMember = onCallTeamArray.filter((oncall) => {
      return oncall.team === team && oncall.onDuty === 1;
    })[0];
    return {
      label: selectedMember.name,
      value: selectedMember.name
    };
  };

  getOnCallTeamChoices = () => {
    const onDutyOnCallTeamUpdated = this.onDutyOnCallTeamUpdated.get();
    const orderedOnCallTeam = onDutyOnCallTeamUpdated.map((oncallTeam) => {
      return {
        id: oncallTeam.id,
        name: oncallTeam.name,
        email: oncallTeam.email,
        phoneNumber: oncallTeam.phoneNumber,
        team: oncallTeam.team,
        selectOnCallMember: {
          name: oncallTeam.name,
          team: oncallTeam.team
        }
      };
    });
    return orderBy(orderedOnCallTeam, ["team"], ["desc"]);
  };
}

const getOnCallTeamStore = memoize(
  () => new OnCallTeamStore(),
  () => 1
);

export default getOnCallTeamStore;
